import React, { Component } from 'react'
import { paragraphToLines, stripHtml } from 'utils/text'

class HeaderSearchResults extends Component {
    ref = null
    tabsHeight = 47

    state = {
        resultsHeight: '',
        activeTabIndex: 0
    }

    componentWillUpdate = nextProps => {
        const {
            activeTabIndex
        } = this.state

        const activeTabKey = Object.keys(nextProps.searchResults)[activeTabIndex]

        if(!activeTabKey || !nextProps.searchResults[activeTabKey] || !nextProps.searchResults[activeTabKey].length){
            let firstIndexWithResults = null

            if(nextProps.searchResults){
                let iterator = 0

                Object.values(nextProps.searchResults).forEach(resultGroup => {
                    if(!firstIndexWithResults && resultGroup.length){
                        firstIndexWithResults = iterator
                    }

                    iterator++
                })
            }

            if(firstIndexWithResults === null){
                firstIndexWithResults = 0
            }
            
            if(firstIndexWithResults !== activeTabIndex){
                this.setState({
                    activeTabIndex: firstIndexWithResults
                })
            }
        }
    }

    goTo = url => {
        this.props.history.push(url)
    }

    handleClick = (key, data) => {
        this.props.dismissResults()
        
        if(key === 'users'){
            this.props.createOrReturnChat(null, data)
        }else{
            this.goTo(data)
        }
    }

    hasResults = _ => {
        let hasResults = false

        Object.keys(this.props.searchResults).forEach(key => {
            const results = this.props.searchResults[key]

            if(results.length){
                hasResults = true
            }
        })

        return hasResults
    }

    setActiveTabIndex = activeTabIndex => {
        this.setState({
            activeTabIndex
        }, _ => {
            this.props.calculateResultsHeight()
        })
    }

    render(){
        const { 
            searchResults, 
            searchTerm, 
            allEntities,
            resultsHeight
        } = this.props

        const {
            activeTabIndex
        } = this.state

        let responseMessage = ''

        if(this.props.isLoading){
            responseMessage = 'Loading...'
        }else if(searchTerm.length < 3){
            responseMessage = 'Please enter at least 3 characters'
        }else if(!this.hasResults()){
            responseMessage = 'No results found for \''+searchTerm+'\''
        }

        return (
            <div className="search-result-list">
                {
                    responseMessage ?
                    <div ref={e => this.ref = e}>
                        { responseMessage }
                    </div>
                    :
                    <section>
                        <ul className="tabs">
                            { Object.keys(searchResults).map((key, index) => {
                                const results = searchResults[key]

                                if(!results.length){
                                    return null
                                }

                                return (
                                    <li
                                        key={key}
                                        className={activeTabIndex == index ? 'active' : null}
                                    >
                                        <button onClick={_ => {this.setActiveTabIndex(index)}}>
                                            { key } ({results.length})
                                        </button>
                                    </li>
                                )
                            }) }
                        </ul>
                        <ul>
                            { Object.keys(searchResults).map(((key, index) => {
                                const results = searchResults[key]
        
                                if(!results.length || activeTabIndex !== index){
                                    return null
                                }
        
                                return (
                                    <li key={index}>
                                        <ul>
                                            {
                                                results.map(result => {
                                                    let name = result.name
                                                    let subtitle = null

                                                    let projectObject = null

                                                    let url = this.props.match.url
                                                    let subtitleUrl = null

                                                    if(result.project_id){
                                                        projectObject = allEntities.projects[result.project_id]
                                                        subtitle = 'from '+projectObject.name
                                                        subtitleUrl = `${this.props.match.url}/projects/${projectObject.slug}`
                                                    }

                                                    switch(key){
                                                        case 'files':
                                                            url += '/projects/'+projectObject.slug+'/files/'+result.id
                                                        break
                                                        case 'notes':
                                                            let allLines = paragraphToLines(result.text);
                                                    
                                                            allLines.forEach(line => {
                                                                if(line && !name){
                                                                    name = line
                                                                }
                                                            });

                                                            url += '/projects/'+projectObject.slug+'/notes'
                                                        break
                                                        case 'projects':
                                                            if(!allEntities.projects[result.id]){
                                                                return null
                                                            }

                                                            url += '/projects/'+allEntities.projects[result.id].slug
                                                        break
                                                        case 'users':
                                                            name = result.first_name+' '+result.last_name

                                                            url = result
                                                        break
                                                        case 'milestones':
                                                            url += `/projects/${projectObject.slug}/tasks?milestone=${result.id}`
                                                        break
                                                        case 'tasks':
                                                            let taskMilestone = allEntities.milestones[result.milestone_id]

                                                            if(!taskMilestone){
                                                                return null
                                                            }

                                                            projectObject = allEntities.projects[taskMilestone.project_id]

                                                            if(!projectObject){
                                                                return null
                                                            }

                                                            subtitle = `from ${projectObject.name}  • ${taskMilestone.name}`
                                                            subtitleUrl = `${this.props.match.url}/projects/${projectObject.slug}/tasks?milestone=${taskMilestone.id}`

                                                            url += '/projects/'+allEntities.projects[taskMilestone.project_id].slug+'/tasks/'+result.id
                                                        break
                                                        case 'comments':
                                                            let commentTask = allEntities.tasks[result.task_id]

                                                            name = stripHtml(result.text)

                                                            if(!commentTask){
                                                                return null
                                                            }else{
                                                                let commentTaskMilestone = allEntities.milestones[commentTask.milestone_id]

                                                                if(!commentTaskMilestone){
                                                                    return null
                                                                }
                                                                
                                                                projectObject = allEntities.projects[commentTaskMilestone.project_id]

                                                                subtitle = 'from '+commentTask.name

                                                                url += '/projects/'+allEntities.projects[commentTaskMilestone.project_id].slug+'/tasks/'+commentTask.id
                                                                subtitleUrl = `${this.props.match.url}/projects/${projectObject.slug}`
                                                            }
                                                        break
                                                    }

                                                    return (
                                                        <li key={result.id} onClick={_ => {this.handleClick(key, url)}}>
                                                            <h4 dangerouslySetInnerHTML={{ __html: name }} />
                                                            <span onClick={e => {
                                                                e.stopPropagation()
                                                                this.handleClick(key, subtitleUrl)
                                                            }}>
                                                                { subtitle }
                                                            </span>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </li>
                                )
                            }))}
                        </ul>
                    </section>
                }
          </div>
        )
    }
}

export default HeaderSearchResults


// WEBPACK FOOTER //
// ./src/layout/header/header-search-results.jsx